<template>
  <div id="app">
    <head-menu @showtabm="istabmshow = true" :headlist="headlist"></head-menu>
    <router-view />
    <footer-com></footer-com>

    <!-- 手机左侧菜单栏 -->
    <div class="tabm" v-if="istabmshow">
      <div class="top">
        <div class="logo">
          <router-link to="/"></router-link>
        </div>
        <span class="iconfont icon-guanbi" @click="istabmshow = false"></span>
      </div>

      <!-- 导航左侧栏 -->
      <div class="tabbox">
        <el-menu default-active="2" class="el-menu-vertical-demo" @select="selectFun" unique-opened router>
          <el-menu-item index="/">
            <span slot="title">home</span>
          </el-menu-item>
          <el-menu-item index="/committee">
            <span slot="title">committee</span>
          </el-menu-item>
          <el-menu-item index="/registration">
            <span slot="title">registration</span>
          </el-menu-item>
          <el-menu-item index="/submission">
            <span slot="title">submission</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <span>program</span>
            </template>
            <el-menu-item index="/program">program</el-menu-item>
            <el-menu-item index="/extended-abstract">extended-abstract</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <span>venue</span>
            </template>
            <el-menu-item index="/venue">venue</el-menu-item>
            <el-menu-item index="/about">about</el-menu-item>
            <el-menu-item index="/hotels">hotels</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>

  </div>
</template>

<script>
import HeadMenu from "@/components/headMenu.vue";
import FooterCom from "@/components/footer.vue";
export default {
  components: {
    HeadMenu,
    FooterCom,
  },
  data() {
    return {
      showtopBtn: false,
      istabmshow: false, // 改 原false
      // // headlist列表格式
      // headlist: [
      //   { title: "Home", path: "/" },
      //   { title: "Committee", path: "/committee" },
      //   { title: "Paper", path: "/paper" },
      //   {
      //     title: "Venue",
      //     path: "/venue",
      //     subMenu: [
      //       { title: "venue", path: "/venue" },
      //       { title: "hotels", path: "/hotels" },
      //     ],
      //   },
      // ],
      headlist: [],
    };
  },
  watch: {
    istabmshow(newVal, oldVal) {
      if (newVal) {
        window.document.documentElement.style.overflow = "hidden";
      } else {
        window.document.documentElement.style.overflow = "visible";
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handelRoutes();
  },
  methods: {
    //pc和电脑公用的导航路由数据
    handelRoutes() {
      let arrRoutes = this.$router.options.routes;
      this.headlist = arrRoutes.map((val) => {
        const item = {
          title: val.name.charAt(0).toUpperCase() + val.name.slice(1),
          path: val.path,
        };
        if (val.children && val.children.length > 0) {
          item.subMenu = val.children.map((child) => ({
            title: child.meta
              ? child.meta.title
              : child.name.charAt(0).toUpperCase() + child.name.slice(1),
            path: child.path,
          }));
        }
        return item;
      });
    },

    // 手机端函数
    selectFun(key, keyPath) {
      if (key) {
        this.istabmshow=false
      }
    },
  },
};
</script>
<style>
.el-menu {
  border-right: 0px;
  background-color: transparent;
}
.el-submenu .el-menu {
  font-weight: 600;
  background: #fff;
}
.el-menu-item{
  font-size: 16px;
}

</style>
<style lang="scss" scoped>
#app {
  // 手机左侧菜单栏
  .tabm {
    width: 100%;
    height: 100vh;
    padding: 20px;
    // background: #fff;
    background: #f7f7f7;
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;

      .logo {
        width: 100px;
        height: 100%;
        // background: url(../src/assets/imgs/ICSR_logo.png) no-repeat center
        background: url(../src/assets/imgs/logo2025.png) no-repeat center
          center;
        background-size: contain;
      }

      .iconfont {
        font-size: 34px;
      }
    }

    .tabbox {
      margin-top: 30px;
      height: calc(100vh - 80px);
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
}
</style>
